import { render, staticRenderFns } from "./docCategory.vue?vue&type=template&id=52fe3afe&scoped=true&"
import script from "./docCategory.vue?vue&type=script&lang=js&"
export * from "./docCategory.vue?vue&type=script&lang=js&"
import style0 from "./docCategory.vue?vue&type=style&index=0&id=52fe3afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe3afe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52fe3afe')) {
      api.createRecord('52fe3afe', component.options)
    } else {
      api.reload('52fe3afe', component.options)
    }
    module.hot.accept("./docCategory.vue?vue&type=template&id=52fe3afe&scoped=true&", function () {
      api.rerender('52fe3afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/docCategory.vue"
export default component.exports